import * as yup from 'yup';
import i18n from '../../../../i18n';

import { ChangeDirectionFormData } from './types';
import { PK_FORMAT_REGEX } from '../../../../utils/transform';
import { pkDentroDeLaCarretera } from '../../../../utils/pkValidation';

export const changeDirectionSchema: yup.ObjectSchema<ChangeDirectionFormData> = yup
  .object()
  .shape({
    pk: yup
      .string()
      .matches(PK_FORMAT_REGEX, () => i18n.t('validation:pk.format'))
    .test('pk-validation', function (value) {
      // Mismo test, mismo nombre y misma clave que los otros cinco formularios
      // que ya validan «PK dentro de la carretera» (NewRoute, NewWorkOrderForm,
      // NewCommunicationForm, LocationForm, ShowOT/WorkOrder). Los extremos
      // viajan como campos del formulario y se leen de `this.parent`.
      if (pkDentroDeLaCarretera(value, this.parent)) return true;
      return this.createError({ message: 'validation:pk.validation' });
    })
      .required(() => i18n.t('validation:required')),
    direction: yup.string().required(() => i18n.t('validation:required')),
    description: yup.string().required(() => i18n.t('validation:required')),
    // Extremos de la carretera del recorrido. No son datos que el operario
    // rellene: los siembra el modal desde la caché de datos maestros para que
    // el test de arriba tenga contra qué comparar. Vacíos = no se valida rango
    // (fail-open deliberado: sin cobertura hay que poder operar igual).
    pkInitRoad: yup.string(),
    pkEndRoad: yup.string(),
  });
